import $http from './http'
import config from './config'

export default {
    name: 'analyse',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    tableList() {
        return $http.get(this.getUrl(`/Analyse/TableList`));
    },
    saveTable(filePath, tableName) {
        return $http.get(this.getUrl(`/Analyse/SaveTableInfo?filePath=${filePath}&tableName=${tableName}`));
    },
    getColumnsByTable(id) {
        return $http.get(this.getUrl(`/analyse/GetColumnsByTable?id=${id}`));
    },
    getList(data) {
        return $http.post(this.getUrl(`/Analyse/List`), data);
    },
    update(data) {
        return $http.post(this.getUrl('/Analyse/Update'), data);
    },
    deleteData(data) {
        /**
         * data:
         * 
         * string TableId 
         * string BatchId
         * string MasterId 
         * 
         * **/
        return $http.post(this.getUrl('/Analyse/DeleteData'), data)
    },
    deleteTable(tableId) {
        return $http.get(this.getUrl('/Analyse/DeleteTable?tableId=' + tableId));
    },
    getLogList(data) {
        return $http.post(this.getUrl('/Analyse/LogList'), data)
    },
    changecolumn(data) {
        return $http.post(this.getUrl('/Analyse/ChangeColumnType'), data)
    }
}



// WEBPACK FOOTER //
// ./src/apis/analyseapi.js